<template>
<div>


<div   v-for=" item of init.bot_list" style="margin:5px">

<v-card  flat style="margin:15px"  >
<v-toolbar   color="#EDEEF0" flat  >


<v-toolbar-side-icon>
<v-tooltip v-if="item.active =='0'" bottom   open-delay="1000" max-width="200"   >
<v-icon @click="activate(item, 1)" color="#808080" large slot="activator" >mdi-star-outline</v-icon>
<span>Бот не активирован, кликните что бы активировать</span>
</v-tooltip>
<v-tooltip v-if="item.active =='1'" bottom   open-delay="1000" max-width="200"   >
<v-icon @click="activate(item, 2)" color="#FF8F18" large slot="activator" >mdi-star</v-icon>
<span>Бот активирован, кликните что бы деактивировать</span>
</v-tooltip>
</v-toolbar-side-icon>


<v-toolbar-title>
<v-flex>
<span style="cursor:pointer;color:#4A76A8;" >  {{item.name}}  </span>
<div v-if="item.active =='0'" style="font-size:0.7em;color:#757575">Бот не активирован, <span @click="activate(item, 1)" style="text-decoration:underline;cursor:pointer">кликните</span> что бы активировать</div>
<div v-if="item.active =='1'" style="font-size:0.7em;color:#FF8F18">Бот активирован, <span @click="activate(item, 2)" style="text-decoration:underline;cursor:pointer">кликните</span> что бы деактивировать</div>
</v-flex>
</v-toolbar-title>




<v-spacer></v-spacer>

<v-tooltip top  max-width="250">
   <span>Двойной  клик, что бы создать новую ссылку, клик что бы просмотреть список ссылок</span>
   <v-btn :disabled="item.params.link_creating" @dblclick="createLink(item)" slot="activator" icon  color="blue"  flat > <v-icon>mdi-link</v-icon></v-btn>
</v-tooltip>

<v-tooltip top  max-width="250">
   <span>Изменить параметры бота</span>
   <v-btn slot="activator" @click="changeParams(item)" icon  color="#273C51"  flat > <v-icon>mdi-tune</v-icon></v-btn>
</v-tooltip>

<v-tooltip top  max-width="250">
   <span> Удалить бот</span>
   <v-btn slot="activator" @click="del(item)" icon  color="blue"  flat> <v-icon color="#C46B19">mdi-close</v-icon> </v-btn>
</v-tooltip>


</v-toolbar>

</v-card>
</div>




</div>
</template>

<script>

import axios from 'axios'
export default {
props:['init'],
data () {
return {

}
},
methods:{
changeParams(item){
this.init.bot = item
this.init.isCreator = false
this.init.modals.creator = true
},

del(item){
this.init.selected = item
this.init.modals.deleteBot = true
},
activate(item, mode){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/telega/activate.php', {
data: {id:item.id, mode:mode},
method: 'post',
}).then(response => {
this.$router.go()
})
},
createLink(item){
item.params.link_creating = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/telega/tele_methods/create_link.php', {
data: {bot_id:item.id},
method: 'post',
}).then(response => {
item.params.link_creating = false
if(response.data.result.invite_link){
window.open(response.data.result.invite_link, '_blank')
}
})
},
},

}
</script>
